import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

function StateDetail() {
  const { stateName } = useParams();
  const [plants, setPlants] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const plantsPerPage = 10;

  // Fetch plants for the selected state
  useEffect(() => {
    axios
      .get(`https://backend-zkgn.onrender.com/api/cogen/state/${stateName}`)
      .then((res) => {
        setPlants(res.data);
        setCurrentPage(1);
      })
      .catch((err) => {
        console.error("Error fetching plants:", err);
        setPlants([]);
      });
  }, [stateName]);

  // Pagination logic
  const totalPages = Math.ceil(plants.length / plantsPerPage);
  const startIndex = (currentPage - 1) * plantsPerPage;
  const currentPlants = plants.slice(startIndex, startIndex + plantsPerPage);

  const handlePrev = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNext = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));

  // Compact pagination function (max 5 visible buttons)
  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(
          1,
          "...",
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }

    return pages;
  };

  return (
    <div className="container my-5">
      <h3 className="mb-4 fw-bold text-dark">
        Cogeneration Plants in {stateName}
      </h3>

      <div className="row">
        {currentPlants.length > 0 ? (
          currentPlants.map((plant, index) => (
            <div key={index} className="col-lg-4 col-md-6 mb-4">
              <div className="card shadow-sm h-100">
                <div className="card-body">
                  <Link
                    className="plant-link text-decoration-none"
                    to={`/cogenerationinfo/${encodeURIComponent(
                      plant.cogen_plant_name
                    )}/${plant.cogen_id}`}
                  >
                    <h5 className="card-title fw-bold text-dark mb-2">
                      {plant.cogen_plant_name}
                    </h5>
                  </Link>
                  <p className="mb-1 plantdetails">
                    <strong className="text-orange">Address:</strong>{" "}
                    {plant.city || "N/A"}
                  </p>
                  <p className="card-text mb-0">
                    <strong>Contact:</strong>{" "}
                    {plant.phone_number || plant.mobile_number || "N/A"}
                  </p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No cogeneration plants found for {stateName}.</p>
        )}
      </div>

      {/* Compact Pagination */}
      {totalPages > 1 && (
        <nav className="d-flex justify-content-center mt-4">
          <ul className="pagination pagination-sm flex-wrap shadow-sm">
            {/* Previous */}
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={handlePrev}>
                ← Prev
              </button>
            </li>

            {getPageNumbers().map((page, index) =>
              page === "..." ? (
                <li key={index} className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              ) : (
                <li
                  key={index}
                  className={`page-item ${
                    currentPage === page ? "active" : ""
                  }`}
                >
                  <button className="page-link" onClick={() => setCurrentPage(page)}>
                    {page}
                  </button>
                </li>
              )
            )}

            {/* Next */}
            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button className="page-link" onClick={handleNext}>
                Next →
              </button>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
}

export default StateDetail;
